<template>
    <v-dialog v-model="ndialog" max-width="450" class="pa-0" scrollable>
        <template v-slot:activator="{ on }">
            <v-btn text v-on="on" >
                <v-icon class="white--text">{{icons.bookmark}}</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <v-btn small rounded outlined @click="offset-=limit, getNotes()" :disabled="offset<=0" >
                    <v-icon>{{icons.arrowleft}}</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                [{{offset}} - {{offset+notes.length}}]
                <v-spacer></v-spacer>
                <v-btn small rounded outlined @click="offset+=limit, getNotes()" :disabled="this.notes.length<limit" >
                    <v-icon>{{icons.arrowright}}</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pa-0 ma-0">
                <v-main class="pt-0">
                    <v-container class="pt-0">
                        <v-row>
                            <v-col class="pt-0">
                                <v-card flat>
                                    <v-list>
                                        <v-list-item v-for="(n,i) in notes" @click="Load(i)"  >
                                            <v-list-item-avatar size="40">
                                                <v-img v-if="n.locationframe" :src="n.locationframe" />
                                                <v-icon v-else class="grey lighten-1 white--text">{{icons.openquote}}</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{n.note}}</v-list-item-title>
                                                <v-list-item-subtitle class="font-weight-light">
                                                    by {{n.useremail}}
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle class="font-weight-light">
                                                    {{ new Date(n.createdAt).toDateString()}}
                                                    {{new Date(n.createdAt).toLocaleTimeString()}}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-main>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="ndialog=false"><v-icon>{{icons.close}}</v-icon> Close</v-btn>
                <v-spacer></v-spacer>
                <AddNote @close="getNotes()" :tag="tag" :orgkey="org.partkey" />
            </v-card-actions>
        </v-card>

        <v-dialog v-model="dialog" persistent  :fullscreen="$vuetify.breakpoint.smAndDown" max-width="900">
            <v-card color="black">
                <div ref="vidbox">
                    <v-btn rounded   @click="closenote()" class="videocloser  ma-0"  color="#00000022">
                        <v-icon class="ol">{{icons.close}}</v-icon>
                    </v-btn>
                    <div class="video-pos-div">
                        <video-player
                                v-if="note.code==='video'"
                                class="video-player-box"
                                ref="videoPlayer"
                                :options="playerOptions"
                                :playsinline="true"
                                @loadeddata="canPlay($event)">
                        </video-player>
                        <v-container fluid class="menubar py-0">
                            <v-row v-if="note.code==='video'" class="">
                                <v-col class="text-center white--text title font-weight-light">
                                    <v-icon class="white--text" style="transform: scale(-1.1);position: relative;bottom:4px;">{{icons.openquote}}</v-icon>
                                    {{note.note}}
                                    <v-icon class="white--text" style="transform: scale(1.1);position: relative;bottom:4px;">{{icons.closequote}}</v-icon>
                                </v-col>
                            </v-row>
                        </v-container>
                    </div>

                    <v-card-text v-if="note.code==='text'" class="headline white--text">
                        <v-container fill-height fluid style="border:solid thin white;border-radius:8px;" class="textbox">
                            <v-layout fill-height >
                                <v-flex xs12 align-end flexbox>
                                    <span class="headline">
                                        <v-icon class="white--text" style="transform: scale(-1.7);">{{icons.openquote}}</v-icon>
                                        {{note.note}}
                                        <v-icon class="white--text" style="transform: scale(1.7);">{{icons.closequote}}</v-icon>
                                    </span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions v-if="fullscreen" >
                        <v-btn  outlined color="white" icon @click="prev()" :disabled="noteindex<=0" ><v-icon>{{icons.arrowleft}}</v-icon></v-btn>
                        <v-spacer></v-spacer>
                        <v-btn  outlined color="white" :disabled="note.code!=='video'" icon @click="play()" v-if="!playing"><v-icon>{{icons.play}}</v-icon></v-btn>
                        <v-btn  outlined color="white" :disabled="note.code!=='video'" icon @click="pause()" v-else><v-icon>{{icons.pause}}</v-icon></v-btn>
                        <v-spacer></v-spacer>
                        <v-btn  outlined color="white" icon :disabled="note.code!=='video'" @click="replay()"><v-icon>{{icons.replay}}</v-icon></v-btn>
                        <v-spacer></v-spacer>
                        <v-btn  icon outlined color="white" :disabled="note.code!=='video'"  @click="toggleslow()"><span>{{pbrate}} x</span></v-btn>
                        <v-spacer></v-spacer>
                        <v-btn v-if="!fullscreen"  outlined color="white" icon @click="setFullscreen()" ><v-icon>{{icons.fullscreen}}</v-icon></v-btn>
                        <v-btn v-else large  outlined color="blue darken-2" icon @click="setFullscreen()" ><v-icon>{{icons.exitfull}}</v-icon></v-btn>
                        <v-spacer></v-spacer>
                        <v-btn  outlined color="white" icon @click="next()" :disabled="this.noteindex>=(notes.length-1)"><v-icon>{{icons.arrowright}}</v-icon></v-btn>
                    </v-card-actions>
                </div>
                <v-card-actions>
                    <v-btn  outlined color="white" icon @click="prev()" :disabled="noteindex<=0" >
                        <v-icon>{{icons.arrowleft}}</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn  outlined color="white" :disabled="note.code!=='video'" icon @click="play()" v-if="!playing"><v-icon>{{icons.play}}</v-icon></v-btn>
                    <v-btn  outlined color="white" :disabled="note.code!=='video'" icon @click="pause()" v-else><v-icon>{{icons.pause}}</v-icon></v-btn>
                    <v-spacer></v-spacer>
                    <v-btn  outlined color="white" icon :disabled="note.code!=='video'" @click="replay()"><v-icon>{{icons.replay}}</v-icon></v-btn>
                    <v-spacer></v-spacer>
                    <v-btn  icon outlined color="white" :disabled="note.code!=='video'"  @click="toggleslow()"><span>{{pbrate}} x</span></v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!fullscreen"  outlined color="white" icon @click="setFullscreen()" ><v-icon>{{icons.fullscreen}}</v-icon></v-btn>
                    <v-btn v-else large  outlined color="blue darken-2" icon @click="setFullscreen()" ><v-icon>{{icons.exitfull}}</v-icon></v-btn>
                    <v-spacer></v-spacer>
                    <v-btn  outlined color="white" icon @click="next()" :disabled="this.noteindex>=(notes.length-1)"><v-icon>{{icons.arrowright}}</v-icon></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--<v-btn @click="devices()">Device</v-btn><v-btn @click="camera()">Camera</v-btn>-->
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  import AddNote from "@/views/notes/AddNote";
  export default {
    name: "NotepadJs",
    components: {AddNote},
    props: ['bookkey', 'api', 'videourl', 'title', 'path','tag'],
    data() {
      return {
        ndialog: false,
        dialog: false,
        headers: [
          {text: 'Note', value: 'note'},
          {text: 'Date', value: 'createdAt'},
        ],
        notes: false,
        offset: 0,
        limit: 8,
        d: [],////break
        noteindex: 3,
        note: {
          id: 0,
          playbackrate: 1,
          videotimestamp: 0,
          duration: 0
        },
        noteid: '',
        src: false,
        video: '',
        videoloop: '',
        loading: true,
        playing: false,
        kind: 'subtitles',
        tracks: '',
        pbrate: 1,
        playbackrates: [0.25, 0.5, 1.0],
        key: '00',
        currLoc: '0',
        fullscreen: false,
        textheight: 200,
        loadingvideo: false,
        playerOptions: {
          autoplay: false,
          muted: true,
          fluid: true,
          language: 'en',
          playbackRates: [.25, .5, 1],
          controlBar: false,
          sources: [{
            type: "video/mp4",
            // mp4
            src: "http://vjs.zencdn.net/v/oceans.mp4",
            // webm
            // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          }],
          poster: "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
        }
      }
    },
    mounted() {
      this.getNotes2()
      window.onpopstate = function (event) {
        console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));
      };
    },
    watch:{
      fullscreen(n,o){
        console.log(n,o)
      },
      tag(n){
        if(n){
          this.getNotes2()
        }
      }
    },
    computed: {
      player() {
        return this.$refs.videoPlayer.player
      },
      menulayout() {
        return (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)) ? 'fixed' : 'absolute'
      },
      ...mapState(['icons','org'])
    },
    methods: {
      ...mapActions(['post','get']),
      async getNotes() {
        let res = await this.get({path:'api/notes/' + 'tag' + '/' + this.tag + '?offset=' + this.offset})
        console.log(res)
        this.notes = res
      },
      async getNotes2() {
        let res = await this.get({path: 'api/notes/tag/' + this.tag})
        console.log(res)
        this.notes = res
      },
      ////////////////
      Load(index) {
        this.noteindex = index
        console.log(this.note)
        this.dialog = true;
        clearInterval(this.videoloop)
        this.note = this.notes[this.noteindex]
        if (this.note.code === 'video') {
          let s = JSON.parse(this.note.src);
          if (this.src !== s[0].src) {
            this.src = s[0].src;
            this.playerOptions.sources = s;
            this.playerOptions.poster = this.note.locationframe;
            this.key = new Date().getTime()
            //this.loadingvideo = true;
            //triggers can play
          } else {
            this.loadvideoloop()
          }
        } else if (this.note.code === 'text') {
          this.loadtext()
        } else {
          return;
        }
      },
      canPlay(e) {
        return this.loadvideoloop()
      },
      loadtext() {
        clearInterval(this.videoloop)
        this.note = this.notes[this.noteindex];

      },
      loadvideoloop() {
        let em = this;
        clearInterval(this.videoloop)
        this.$nextTick(function () {
          let stamp = parseFloat(em.note.videotimestamp)
          let dur = parseFloat(em.note.duration)
          let end = parseFloat(stamp + dur)
          em.player.currentTime(stamp);
          em.player.playbackRate(em.note.playbackrate);
          em.pbrate = this.note.playbackrate;
          em.player.play();
          em.playing = true;
          em.loadingvideo = false;
          this.videoloop = setInterval(function () {
            em.currLoc = stamp
            if (em.player.currentTime() > end) {
              em.player.currentTime(stamp);
            }
          }, 100);
        })
      },
      closenote() {
        clearInterval(this.videoloop)
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
        this.dialog = false
        if (this.note.code === 'video') this.player.pause()
      },
      replay() {
        this.player.currentTime(this.note.videotimestamp)
      },
      toggleslow() {
        //change to indexed array; faster
        let r = this.player.playbackRate();
        let index = this.playbackrates.indexOf(r);
        let ln = this.playbackrates.length;
        index++;
        if (index == ln) index = 0;
        this.pbrate = this.playbackrates[index];
        this.player.playbackRate(this.playbackrates[index])
      },
      play() {
        this.player.playbackRate(this.note.playbackrate)
        this.pbrate = this.note.playbackrate;
        this.player.play();
        this.playing = true;
      },
      pause() {
        this.player.pause();
        this.playing = false;
      },
      prev() {
        this.noteindex--
        this.Load(this.noteindex)
      },
      next() {
        this.noteindex++
        this.Load(this.noteindex++)
      },
      setFullscreen() {
        let elem = this.$refs.vidbox;
        let em = this;
        elem.addEventListener("fullscreenchange", function (event) {
          em.screencheck()
        });
        if (!document.fullscreenElement) {
          elem.requestFullscreen().then({/*do nothing else for now*/}).catch(err => {
            alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
          });
        } else {
          document.exitFullscreen();
        }
      },
      screencheck() {
        if (document.fullscreenElement) {
          this.fullscreen = true;
        } else {
          this.fullscreen = false;
        }
      },
      canPlayThrough(e) {
        console.log("canplay through: ", e)
      }
    }
  }
</script>

<style scoped>
    .ol{
        color: white;
        -webkit-text-fill-color: white; /* Will override color (regardless of order) */
        -webkit-text-stroke-width: 1px;
        -webkit-text-stroke-color: black;
        transform: scale(1.5);
    }
    .active{
        outline:solid thin #0D47A1;
        color:#0D47A1;
    }
    .videocloser{
        position:absolute;
        top:10px;
        right:15px;
        z-index:2000;
    }
    .video-pos-div{
        position: relative;
        display: block;
        background-color: black;
        /*overflow: hidden;*/
    }
    ::cue {
        color: white;
        opacity: .6;
        background: rgba(0,0,0,.6);
    }
    .menubar{
        display: block;
        position:absolute;
        bottom:0;
        left:0;
        z-index:12999;
        color:#fff;
        background-color: rgba(0,0,0,.4);
        width:100vw;
        /*cursor: pointer;*/
        /*text-align: center;*/
    }
</style>